import { getController, apiService as Service, type HpRequestPostPut } from '../service'

const url = 'craftsman_tasks'

export const craftsmanTaskService = {
	...getController<
		Api.CraftsmanTask,
		Api.CraftsmanTaskPostInput,
		Api.CraftsmanTaskUpdateInput
	>(url),
	postComment: ({
		module_id,
		history_id,
		data,
	}: {
		module_id: number
		history_id: number
		data: HpRequestPostPut<unknown>
	}) =>
		Service.post({
			url: `${url}/${module_id}/history/${history_id}/comments`,
			...data,
		}),
	updateComment: ({
		module_id,
		history_id,
		comment_id,
		data,
	}: {
		module_id: number
		history_id: number
		comment_id: number
		data: HpRequestPostPut<unknown>
	}) =>
		Service.put({
			url: `${url}/${module_id}/history/${history_id}/comments/${comment_id}`,
			...data,
		}),
	removeComment: ({
		module_id,
		history_id,
		comment_id,
	}: Record<string, number>) =>
		Service.delete({
			url: `${url}/${module_id}/history/${history_id}/comments/${comment_id}`,
		}),
}

export default craftsmanTaskService
